module.exports = __webpack_public_path__ + "static/about-1-4-2-b0ce1d9ca6bfaeadb4d7d79fdc5d2aed.png";